<article class="promotion-card">
  <div class="promotion-card__media">
    <img
      class="promotion-card__image"
      [src]="bannerSrc"
      [alt]="bannerAlt"
      loading="lazy"
    />
    @if (showExpiryBadge) {
      <div class="promotion-card__urgency-badge" role="status">
        <mat-icon
          class="promotion-card__urgency-icon"
          svgIcon="priority_high"
          aria-hidden="true"
        ></mat-icon>
        <span class="promotion-card__urgency-text">{{ expiryBadgeLabel }}</span>
      </div>
    }
  </div>

  <div class="promotion-card__body">
    @if (hasStructuredHeadline) {
      <div class="promotion-card__summary">
        @if (operationLabel) {
          <span class="promotion-card__operation-badge">{{
            operationLabel
          }}</span>
        }
        @if (currencyLabel) {
          <p class="promotion-card__currency">{{ currencyLabel }}</p>
        }
        <p class="promotion-card__price-new">{{ newPriceLabel }}</p>
        <p class="promotion-card__price-before">
          <span class="promotion-card__price-before-label">{{
            'LANDING.PROMOTIONS.PRICE_BEFORE' | translate
          }}</span>
          <span class="promotion-card__price-old">{{ oldPriceLabel }}</span>
        </p>
      </div>
    } @else {
      <div class="promotion-card__summary">
        <p class="promotion-card__headline-text promotion-card__headline-text--plain">
          {{ fallbackHeadline }}
        </p>
      </div>
    }

    <div class="promotion-card__meta-outer">
      <div class="promotion-card__meta-inner">
        @if (branchLabel) {
          <div class="promotion-card__chip">
            <span class="promotion-card__chip-icon-wrap" aria-hidden="true">
              <img
                class="promotion-card__chip-logo"
                src="./assets/img/isotipo.svg"
                alt=""
                width="16"
                height="16"
              />
            </span>
            <span class="promotion-card__chip-text">{{ branchLabel }}</span>
          </div>
        }

        @if (availabilityLabel) {
          <div class="promotion-card__chip promotion-card__chip--availability">
            <mat-icon class="promotion-card__mat-icon" svgIcon="access_time"></mat-icon>
            <span class="promotion-card__chip-text">{{ availabilityLabel }}</span>
          </div>
        }

        @if (validityLabel) {
          <div class="promotion-card__chip">
            <mat-icon class="promotion-card__mat-icon" svgIcon="event"></mat-icon>
            <span class="promotion-card__chip-text">{{ validityLabel }}</span>
          </div>
        }

        @if (discountLabel) {
          <div class="promotion-card__chip">
            <mat-icon class="promotion-card__mat-icon" svgIcon="local_offer"></mat-icon>
            <span class="promotion-card__chip-text">{{ discountLabel }}</span>
          </div>
        }
      </div>
    </div>

    <div class="promotion-card__actions">
      <button
        type="button"
        class="promotion-card__btn promotion-card__btn--primary"
        (click)="onReserve()"
      >
        <span class="promotion-card__btn-label">{{
          'HOME_BRANCHES.RESERVE_BUTTON' | translate
        }}</span>
        <mat-icon class="promotion-card__btn-icon" svgIcon="payments"></mat-icon>
      </button>
      <button
        type="button"
        class="promotion-card__btn promotion-card__btn--ghost"
        (click)="onDetail()"
        [attr.aria-label]="'LANDING.PROMOTIONS.CARD_VIEW_DETAILS_ARIA' | translate"
      >
        <mat-icon class="promotion-card__btn-icon" svgIcon="visibility"></mat-icon>
      </button>
    </div>
  </div>
</article>
